// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2scoU","signatureButtonsRight":"ModalSign_signatureButtonsRight__2nJK_"};